import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { userService } from '../services/api';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const { currentUser } = useAuth();

  const languages = [
    { code: 'ca', name: 'Català' },
    { code: 'en', name: 'English' },
    { code: 'es', name: 'Español' }
  ];

  const changeLanguage = async (langCode) => {
    i18n.changeLanguage(langCode);
    
    // Update user's preferred language in the database if logged in
    if (currentUser && currentUser.id) {
      try {
        await userService.updateUser(currentUser.id, {
          preferred_language: langCode
        });
      } catch (error) {
        console.error('Failed to update preferred language:', error);
      }
    }
  };

  return (
    <div className="relative">
      <select
        value={i18n.language}
        onChange={(e) => changeLanguage(e.target.value)}
        className="w-full bg-white border border-neutral-300 text-neutral-700 text-sm rounded-md px-2 py-1 focus:ring-2 focus:ring-accent-500 focus:border-accent-500"
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;